/**
 * Measurement Guide Drawer JavaScript
 * Handles the right-side slide-in panel functionality
 */

(function() {
  'use strict';

  const DRAWER_SELECTOR = '.measurement-guide-drawer';
  const OVERLAY_SELECTOR = '.measurement-guide-overlay';
  const CLOSE_BTN_SELECTOR = '.measurement-guide-close';
  const OPEN_TRIGGER_SELECTOR = '.measurement-guide-trigger';
  const BODY_CLASS = 'measurement-guide-open';

  let drawer = null;
  let overlay = null;
  let isOpen = false;

  /**
   * Initialize the measurement guide drawer functionality
   */
  function init() {
    drawer = document.querySelector(DRAWER_SELECTOR);
    overlay = document.querySelector(OVERLAY_SELECTOR);

    if (!drawer || !overlay) {
      console.warn('Measurement Guide Drawer: Required elements not found');
      return;
    }

    // Bind event listeners
    bindEvents();
  }

  /**
   * Bind all event listeners
   */
  function bindEvents() {
    // Close button click
    const closeBtn = drawer.querySelector(CLOSE_BTN_SELECTOR);
    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }

    // Overlay click to close
    overlay.addEventListener('click', closeDrawer);

    // Escape key to close
    document.addEventListener('keydown', handleKeyDown);

    // Trigger links click
    document.querySelectorAll(OPEN_TRIGGER_SELECTOR).forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    });

    // Prevent scroll on touch devices when drawer is open
    drawer.addEventListener('touchmove', preventScroll, { passive: false });
  }

  /**
   * Handle keyboard events
   * @param {KeyboardEvent} e
   */
  function handleKeyDown(e) {
    if (e.key === 'Escape' && isOpen) {
      closeDrawer();
    }
  }

  /**
   * Prevent scroll when touching the drawer
   * @param {Event} e
   */
  function preventScroll(e) {
    if (isOpen) {
      e.preventDefault();
    }
  }

  /**
   * Open the drawer
   */
  function openDrawer() {
    if (isOpen) return;

    isOpen = true;
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.classList.add(BODY_CLASS);

    // Focus management for accessibility
    const closeBtn = drawer.querySelector(CLOSE_BTN_SELECTOR);
    if (closeBtn) {
      closeBtn.focus();
    }

    // Dispatch custom event
    document.dispatchEvent(new CustomEvent('measurementGuide:opened'));
  }

  /**
   * Close the drawer
   */
  function closeDrawer() {
    if (!isOpen) return;

    isOpen = false;
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.classList.remove(BODY_CLASS);

    // Return focus to the trigger
    const lastTrigger = document.querySelector('.measurement-guide-trigger:focus');
    if (lastTrigger) {
      lastTrigger.focus();
    }

    // Dispatch custom event
    document.dispatchEvent(new CustomEvent('measurementGuide:closed'));
  }

  /**
   * Toggle the drawer state
   */
  function toggleDrawer() {
    if (isOpen) {
      closeDrawer();
    } else {
      openDrawer();
    }
  }

  /**
   * Check if drawer is currently open
   * @returns {boolean}
   */
  function isDrawerOpen() {
    return isOpen;
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose public methods for external use
  window.MeasurementGuideDrawer = {
    open: openDrawer,
    close: closeDrawer,
    toggle: toggleDrawer,
    isOpen: isDrawerOpen
  };

})();
